export default "__VITE_ASSET__BEb7DUG4__"